/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import {faStream, faChartBar, faLayerGroup, faCheckSquare, faTh} from '@fortawesome/free-solid-svg-icons';

export default {
  login: {path: '/login'},
  channels: {
    path: 'channels',
    icon: faStream
  },
  rooms: {
    path: 'rooms',
    icon: faLayerGroup
  },
  analytics: {
    path: 'analytics',
    icon: faChartBar
  },
  qos: {
    path: 'qos',
    icon: faCheckSquare,
    notSupported: true
  },
  dashboard: {
    path: 'dashboard',
    icon: faTh
  }
};